/*
 * @Author: Teemo Ding
 * @Date: 2021-09-30 09:34:10
 * @LastEditTime: 2022-06-10 09:36:21
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelTax/TaxRuleNameLocalisation/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import LocalisationSetting from '../Components/LocalisationSetting';
import css from '../css.module.less';

const TaxSetting = ({
  disabled,
  disableEdit,
}: {
  disabled?: boolean;
  disableEdit?: boolean;
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelTax.index.taxRuleNameLocalisation')}>
      {disabled ? null : (
        <Form.Item name='localization'>
          <LocalisationSetting disabled={disableEdit} />
        </Form.Item>
      )}
    </SectionWrapper>
  );
};

export default TaxSetting;
